
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAuthState } from '@state/reducers/auth/auth.reducer';
import { IState } from '@state/state.module';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

    constructor(private store: Store<IState>, private authService: AuthService) {
        this.state = this.store.select(x => x.auth);
        this.state.pipe(
            filter(x => !!x),
            tap(x => {
                //
            }),)
            .subscribe(x => this.token = !!x.principal.token ? x.principal.token.encoded : null);
    }

    private state: Observable<IAuthState>;
    private token: string;

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.url.indexOf('api/multitenantlogins') !== -1) {
            return next.handle(request);
        }
        else if (request.url.indexOf('connect/token') !== -1) {
            return next.handle(request);
        }

        const h: { [name: string]: string | string[] } = { };
        for (const key of request.headers.keys()) {
            h[key] = request.headers.getAll(key);
        }

        if (!!this.token) {
            h['Authorization'] = 'Bearer ' + this.token;
        }

        const headers = new HttpHeaders(h);
        const r = request.clone({ headers });

        return next.handle(r);
    }
}
